export default "__VITE_ASSET__Dk$sIZND__"